/* PetShopKingdom — efecto permitido (DESIGN.md): fade-in + subida al
   entrar en viewport. IntersectionObserver ligero, sin librerías.
   Ficha de producto, home y páginas informativas. Respeta
   prefers-reduced-motion y, si algo falla, no oculta nada. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  function init() {
    var main = document.querySelector('main[data-template="product"], main[data-template="index"], main[data-template="page"]');
    if (!main) return;

    // v2.18 (R-22): además de las secciones de nivel superior, se observan
    // las bandas internas marcadas con [data-psk-reveal] — en páginas largas
    // de una sola sección (quienes-somos) cada banda anima al entrar ELLA
    // en viewport, no cuando entra la sección entera.
    var sections = main.querySelectorAll(':scope > .shopify-section, [data-psk-reveal]');
    if (!sections.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('psk-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    sections.forEach(function (section) {
      // v2.21: las secciones con coreografía propia ligada al scroll (sticky
      // stacking) NO entran al reveal: el opacity:0 inicial las ocultaba
      // durante toda la fase de aproximación (una sección de ~2 pantallas
      // necesita ~24vh de scroll interno para llegar al threshold) y el
      // transform del ancestro desactiva position:sticky — el paso 01
      // transcurría invisible y lo primero que se veía era el 02 entrando.
      if (section.querySelector && section.querySelector('.psk-stack')) return;
      // PERF #9 (01/10): los HEROES tampoco entran al reveal. Son el elemento
      // que marca el LCP y .psk-reveal los dejaba en opacity:0 — y un elemento
      // con opacity:0 no es candidato a LCP. Habia que esperar a que bajara
      // este script (defer), saltara DOMContentLoaded, se disparara el
      // IntersectionObserver y corriera un fade de 0,6 s: ahi estaba el grueso
      // de los 7,6 s de LCP en movil. Ademas el reveal nunca tuvo sentido aqui:
      // un hero no se "entra al hacer scroll", ya esta en pantalla al cargar.
      //   .psk-hhero  (home)  conserva su cascada propia: clip del titular ->
      //               subtitulo -> CTA.
      //   .hero-lima  (ficha) es la primera pantalla completa en movil, donde
      //               .hero-lima__media va display:none y el LCP es su H1; en
      //               escritorio el LCP es la escena de su columna derecha.
      //               En los dos casos el elemento vive en esta seccion.
      // El resto de la ficha sigue revelandose con scroll, y la lamina .product
      // mantiene su entrada propia por animation-timeline: view() (v2.33).
      if (section.querySelector && section.querySelector('.psk-hhero, .hero-lima')) return;
      section.classList.add('psk-reveal');
      observer.observe(section);
    });
    // Nota: sin salvavidas en window.load — revelaba TODAS las secciones al
    // cargar y las animaciones de scroll ya habían corrido al llegar a ellas.
    // Si IntersectionObserver no existe, ya salimos antes y nada queda oculto.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* Con prefers-reduced-motion, pausar los vídeos ambientales (hero/demo). */
(function () {
  if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.demo__video').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }, { once: true });
})();

/* Vídeo de la sección "La calma también se ve": reproducir solo en viewport
   y pausar al salir (ahorro de datos/batería). Sin reduced-motion.
   v2.29 (responsive móvil): también en móvil — iOS reproduce en línea con
   muted+playsinline. Si el navegador rechaza el play() (iPhone en ahorro de
   batería, políticas de datos), FALLBACK REAL: .demo__media--noplay enseña
   el póster en lugar de dejar un rectángulo congelado. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  function init() {
    var vids = document.querySelectorAll('.demo__video');
    if (!vids.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          if (p && p.catch) {
            p.catch(function () {
              var media = v.closest('.demo__media');
              if (media) media.classList.add('demo__media--noplay');
            });
          }
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* v2.18 (R-01): el tilt 3D del producto destacado se retira — era el único
   efecto fuera del sistema permitido por DESIGN.md (fade-in + hovers). */

/* Barra sticky de compra en móvil: aparece al hacer scroll pasada la ficha.
   Reutiliza el formulario real de Dawn (el botón dispara el submit AJAX nativo). */
(function () {
  function initStickyAtc() {
    var main = document.querySelector('main[data-template="product"]');
    if (!main || document.querySelector('.psk-sticky-atc')) return;
    var info = main.querySelector('[id^="ProductInfo-"]');
    var submit = main.querySelector('.product-form__submit');
    if (!info || !submit || !('IntersectionObserver' in window)) return;

    var img = main.querySelector('.product__media img');
    var priceEl = main.querySelector('.price .price-item');
    var price = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var label = (window.variantStrings && window.variantStrings.addToCart) || 'Agregar al carrito';

    var bar = document.createElement('div');
    bar.className = 'psk-sticky-atc';
    if (img) {
      var thumb = document.createElement('img');
      thumb.src = img.currentSrc || img.src;
      thumb.alt = '';
      bar.appendChild(thumb);
    }
    var priceSpan = document.createElement('span');
    priceSpan.className = 'psk-sticky-atc__price';
    priceSpan.textContent = price;
    bar.appendChild(priceSpan);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'psk-sticky-atc__btn psk-btn';
    btn.textContent = label;
    btn.addEventListener('click', function () { submit.click(); });
    bar.appendChild(btn);
    document.body.appendChild(bar);

    /* Precio/estado EN VIVO (auditoría P-01): antes se capturaban una sola
       vez y al cambiar de variante la barra mostraba el precio viejo y el
       botón seguía activo aunque el ATC real estuviera deshabilitado.
       Doble cobertura: evento variant-change de Dawn + MutationObserver
       (por si el evento llega antes de que el DOM del precio se actualice). */
    var thumbEl = bar.querySelector('img');
    var syncBar = function () {
      var p = main.querySelector('.price .price-item');
      if (p) priceSpan.textContent = p.textContent.replace(/\s+/g, ' ').trim();
      var off = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      btn.disabled = off;
      btn.textContent = off ? ((window.variantStrings && window.variantStrings.soldOut) || label) : label;
      var i = main.querySelector('.product__media img');
      if (thumbEl && i) thumbEl.src = i.currentSrc || i.src;
    };
    if (window.subscribe && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { window.setTimeout(syncBar, 0); });
    }
    if ('MutationObserver' in window) {
      var priceWrap = main.querySelector('.price');
      if (priceWrap) new MutationObserver(syncBar).observe(priceWrap, { childList: true, subtree: true, characterData: true });
      new MutationObserver(syncBar).observe(submit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }
    syncBar();

    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', passed);
      document.body.classList.toggle('psk-sticky-open', passed);
    }, { threshold: 0 });
    io.observe(info);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc, { once: true });
  } else {
    initStickyAtc();
  }
})();
